<template>
  <div class="article-history">
    <div class="header">
      <i class="material-icons">history</i>
      <h3>{{ $store.state.user.langEng ? "History" : "Historik" }}</h3>
    </div>
    <div v-if="lastVisited.length > 0" class="sidenav-close">
      <div
        v-for="visited of lastVisited"
        :key="visited.id"
        class="history-item"
      >
        <router-link
          class="link truncate black-text"
          :to="'/article/' + visited.slug"
          >{{ visited.title }}</router-link
        >
      </div>
    </div>
    <div v-else>
      <p>
        {{
          $store.state.user.langEng
            ? "No history available"
            : "Ingen historik tillgänglig"
        }}
      </p>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component
export default class LastSeenArticles extends Vue {
  get lastVisited() {
    return this.$store.state.user.lastVisited;
  }

  navArticle(article) {
    this.$router.push({
      name: "article",
      params: {
        slug: article.slug,
      },
    });
  }
}
</script>

<style scoped lang="scss">
.article-history {
  .header {
    align-items: center;
    display: grid;
    column-gap: 0.5em;
    grid-template-columns: auto 1fr auto;
    margin: 0.5em 0 0.5em;
    h3 {
      font-size: 1.5rem;
    }
    .rubbish-bin {
      margin-left: 7.8rem;
    }
  }
  .history-item {
    border-radius: 5px;
    padding: 0 0.3em;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
